module.exports = __webpack_public_path__ + "img/confidencial-nanny.cdb18ec5.jpg";